import { ICastCrewDTO, IJudgeSpecialityDTO, IPaginationDTO, ISettingsDTO } from '@/dtos';
import { generatePagination, get, post, remove } from '../apiWrapper';

export const getAllSettingsAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: ISettingsDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const admins = await get<{ data: ISettingsDTO[]; count: number }>(
    `/admin/settings${pageOptions}`,
  );
  return admins;
};

export const createSettingAPI = async (setting: ISettingsDTO): Promise<ISettingsDTO> => {
  const notes = await post<ISettingsDTO>(`admin/settings`, setting);
  return notes;
};

export const updateSettingAPI = async (setting: ISettingsDTO): Promise<ISettingsDTO> => {
  const result = await post<ISettingsDTO>(`/admin/settings/${setting.id}`, setting);
  return result;
};

export const deleteSettingAPI = async (settingId: string): Promise<boolean> => {
  const result = await remove<boolean>(`/admin/settings/${settingId}`);
  return result;
};

export const createCastAndCrewSettingAPI = async (
  castSetting: ICastCrewDTO,
): Promise<ICastCrewDTO> => {
  const notes = await post<ICastCrewDTO>(`/admin/settings/castandcrew/create`, castSetting);
  return notes;
};

export const updateCastAndCrewSettingAPI = async (
  castSetting: ICastCrewDTO,
): Promise<ICastCrewDTO> => {
  const result = await post<ICastCrewDTO>(
    `/admin/settings/castandcrew/${castSetting.id}`,
    castSetting,
  );
  return result;
};

export const deleteCastAndCrewSettingAPI = async (castSettingId: string): Promise<boolean> => {
  const result = await remove<boolean>(`/admin/settings/castandcrew/${castSettingId}`);
  return result;
};

export const createJudgeSpecialtiesSettingAPI = async (
  judgeSetting: IJudgeSpecialityDTO,
): Promise<IJudgeSpecialityDTO> => {
  const result = await post<IJudgeSpecialityDTO>(
    `/admin/settings/judgespecialty/create`,
    judgeSetting,
  );
  return result;
};

export const updateJudgeSpecialtySettingAPI = async (
  judgeSetting: IJudgeSpecialityDTO,
): Promise<IJudgeSpecialityDTO> => {
  const result = await post<IJudgeSpecialityDTO>(
    `/admin/settings/judgespecialty/${judgeSetting.id}`,
    judgeSetting,
  );
  return result;
};

export const deleteJudgeSpecialtySettingAPI = async (judgeSettingId: string): Promise<boolean> => {
  const result = await remove<boolean>(`/admin/settings/judgespecialty/${judgeSettingId}`);
  return result;
};

export const getAllJudgeSpecialitiesSettingsAPI = async (
  pagination?: IPaginationDTO,
): Promise<{ data: IJudgeSpecialityDTO[]; count: number }> => {
  let pageOptions = '';
  if (pagination) {
    pageOptions = await generatePagination(pagination);
  }

  const admins = await get<{ data: IJudgeSpecialityDTO[]; count: number }>(
    `/admin/settings/judgespecialities${pageOptions}`,
  );
  return admins;
};
